import React from 'react';

export default ({children}) => <div className="maintabs-block">{children}</div>;
